import React, {Component} from 'react';
import {deepCopyObject, filterCities, getCitySubdivisions_, showAxiosError, trimObject} from "../../util/Helpers";
import {DatePicker, Form, input, Input} from "antd";
import Select from "../../local_node_modules/react-select"
import moment from "moment";
import {Label, UncontrolledTooltip} from "reactstrap";
import './MemberList.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import {validateComponent, validateField} from "../../common/validation";
import Alert from "react-s-alert";
import _ from 'lodash';
import Uploader2 from "../../components/Uploader/Uploader2";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import Maskedinput from "react-text-mask";
import emailMask from "text-mask-addons/dist/emailMask";

const {TextArea} = input;

class MemberGeneralInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            isLoading: false,
            fieldsDisabled: false,
            mode: this.props.mode,
            hasPendingRequest: false,
            changeRequest: {
                id: null,
                ad: "",
                soyad: "",
                tcKimlikNo: "",
                dogumTarihi: null,
                babaAdi: "",
                anaAdi: "",
                medeniHali: "",
                kanGrubu: "",
                universite: "",
                mezuniyetTarihi: null,
                diplomaNo: "",
                ruhsatNo: "",
                ruhsatTarihi: null,
                vergiDairesiAd: "",
                vergiNo: "",
                fotoFile: "",
                fotoThumbFile: "",
                fotoPath: "",
                email: "",
                evTel: "",
                gsmTel: "",
                isTel: "",
                uyeCalisiyor: null,
                addressList: [
                    {
                        id: null,
                        addressType: 'PERMANENT',
                        addressString: null,
                        permSemt: null,
                        cityId: null,
                        citysubdivisionId: null,
                        memberId: null,
                    },
                    {
                        id: null,
                        addressType: 'WORK',
                        addressString: null,
                        workSemt: null,
                        cityId: null,
                        citysubdivisionId: null,
                        memberId: null
                    }
                ],
            },
            memberInfo: {
                id: null,
                ad: "",
                soyad: "",
                eskiSoyad: "",
                tcKimlikNo: "",
                dogumTarihi: null,
                kimlikTipi: "",
                cuzdanKimlikSeriNo: "",
                kayitNo: "",
                kimlikSonGecerlilikTarihi: null,
                babaAdi: "",
                anaAdi: "",
                dogumYeri: "",
                medeniHali: "",
                kanGrubu: "",
                eposta: "",
                evTel: "",
                gsmTel: "",
                isTel: "",
                isAdres: "",
                ikametAdres: "",
                odaKayitTarihi: "",//
                odaSicilNo: "",//
                universite: "",
                belgeTuru: "",
                mezuniyetTarihi: null,
                diplomaNo: "",
                gozRuhTarih: null,
                gozRuhNo: "",
                gozRuhKurum: "",
                ruhsatTarihi: null,
                ruhsatNo: "",
                vergiDairesiAd: "",
                vergiNo: "",
                fotoFile: "",
                kimlikCuzdanFile: "",
                adliSicilFile: "",
                ruhsatnameFile: "",
                diplomaFile: "",
                ikametgahFile: "",
                fotoThumbFile: "",
                calismaBelgesiFile: "",
                kimlikCuzdanThumbFile: "",
                adliSicilThumbFile: "",
                ruhsatnameThumbFile: "",
                diplomaThumbFile: "",
                ikametgahThumbFile: "",
                calismaBelgesiThumbFile: "",
                fotoPath: "",
                kimlikCuzdanPath: "",
                adliSicilPath: "",
                ruhsatnamePath: "",
                diplomaPath: "",
                ikametgahPath: "",
                calismaBelgesiPath: "",
                basvuruDurumu: "",
                basvuruReddedilmeSebebi: "",
                ruhsatAktif: true,
                uyelikAktif: true,
                uyeCalisiyor: true,
                kendiIsyeri: false,
                mesulMudur: false,
                kamuPersoneli: false,
                eczaci: false,
                uyelikPasiflikNedeni: "",
                user_id: "",
                username: "",
                email: "",
                cinsiyet: "",
                muesseseAdi: "",
                muesseseSahibi: "",
                isTransferred: false,
                calismaBelgeli: false,
                city: {
                    id: null,
                    plakaKod: null,
                    ad: null,
                    oda: {
                        id: null,
                        ad: null,
                        adres: null,
                        telefonNo: null,
                        email: null,
                        webSitesiURL: null,
                        kurulusKararNo: null
                    }
                },
                addressList: [
                    {
                        id: null,
                        addressType: 'PERMANENT',
                        addressString: null,
                        permSemt: null,
                        cityId: null,
                        citysubdivisionId: null,
                        memberId: null,
                    },
                    {
                        id: null,
                        addressType: 'WORK',
                        addressString: null,
                        workSemt: null,
                        cityId: null,
                        citysubdivisionId: null,
                        memberId: null
                    }
                ]
            },
            permanentAdrsCities: null,
            workAdrsCities: null,
            permanentAdrsCitySubdivisions: null,
            workAdrsCitySubdivisions: null,
        };

        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
        this.saveChangeRequest = this.saveChangeRequest.bind(this);
        this.onChangeRequest = this.onChangeRequest.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.filterChangedFields = this.filterChangedFields.bind(this);
        this.fetchMember = this.fetchMember.bind(this);
        this.onChangeAddress = this.onChangeAddress.bind(this);
        this.checkChange = this.checkChange.bind(this);
        this.checkChangeAddress = this.checkChangeAddress.bind(this);
        this.onChangeRequestLowerCase = this.onChangeRequestLowerCase.bind(this);
        this.copyObject = this.copyObject.bind(this);
        this.isEmtpyRequest = this.isEmtpyRequest.bind(this);
        this.fetchPendingRequest = this.fetchPendingRequest.bind(this);
        this.deleteChangeRequest = this.deleteChangeRequest.bind(this);
        this.addChangedFields = this.addChangedFields.bind(this);
        this.fetchChangeRequest = this.fetchChangeRequest.bind(this);
        this.denyChangeRequest = this.denyChangeRequest.bind(this);
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }


    async componentDidMount() {
        if (this.props.selectedMember || this.props.selectedChangeRequest) {
            let selectedMember;
            let pendingRequest;
            let memberInfo;
            let changeRequest;
            let citySubdivisions = await this.listCitySubdivisions();
            let cities = await this.listCities();
            let permanentAdrsCitySubdivisions = [];
            let workAdrsCitySubdivisions = [];
            let permanentAdrsCities = [];
            let workAdrsCities = [];

            if (this.props.mode && (this.props.mode === 'review' || this.props.mode === 'edit')) {
                pendingRequest = await this.fetchPendingRequest((this.props.mode && this.props.mode === 'review')
                    ? this.props.selectedChangeRequest && this.props.selectedChangeRequest.member.id
                    : this.props.selectedMember && this.props.selectedMember.id);

                selectedMember = await this.fetchMember((this.props.mode && this.props.mode === 'review')
                    ? this.props.selectedChangeRequest && this.props.selectedChangeRequest.member.id
                    : this.props.selectedMember && this.props.selectedMember.id);

                memberInfo = deepCopyObject(selectedMember);
                changeRequest = this.copyObject(deepCopyObject(this.state.changeRequest), memberInfo);

                if (pendingRequest != null && this.props.mode && (this.props.mode === 'review' || this.props.mode === 'edit') && pendingRequest.processState !== "DENIED") {
                    changeRequest = this.addChangedFields(pendingRequest, changeRequest);
                    console.log("changeRequest", changeRequest);
                }

            } else {
                pendingRequest = await this.fetchChangeRequest(this.props.selectedChangeRequest && this.props.selectedChangeRequest.id);
                changeRequest = this.addChangedFields(pendingRequest, this.state.changeRequest);

            }

            if (this.props.mode && this.props.mode === 'edit') {
                permanentAdrsCitySubdivisions = (selectedMember.addressList.length > 0) ? getCitySubdivisions_(selectedMember.addressList[0].cityId, citySubdivisions) : null;
                workAdrsCitySubdivisions = (selectedMember.addressList.length > 0) ? getCitySubdivisions_(selectedMember.addressList[1].cityId, citySubdivisions) : null;
                permanentAdrsCities = (this.props.currentUser.realm === 0) ? filterCities(cities, 1000) : selectedMember.uyeCalisiyor ? filterCities(cities, 1000) : filterCities(cities, this.props.currentUser.member.city.oda.id);
                workAdrsCities = (this.props.currentUser.realm === 0) ? filterCities(cities, 1000) : filterCities(cities, this.props.currentUser.member.city.oda.id);

            } else if (this.props.mode && this.props.mode !== 'edit') {

                permanentAdrsCitySubdivisions = getCitySubdivisions_(null, citySubdivisions);
                workAdrsCitySubdivisions = getCitySubdivisions_(null, citySubdivisions);
                permanentAdrsCities = filterCities(cities, 1000);
                workAdrsCities = filterCities(cities, 1000);
            }

            this.setState({
                memberInfo,
                changeRequest,
                permanentAdrsCitySubdivisions,
                workAdrsCitySubdivisions,
                permanentAdrsCities,
                workAdrsCities,
                citySubdivisions,
                cities
            });
        }
    }

    copyObject(object1, object2) {
        if (object1 !== null && object2 !== null) {
            for (const [key, value] of Object.entries(object1)) {
                if (object2[key] !== undefined) {
                    object1[key] = deepCopyObject(object2[key]);
                }
            }
        }
        return object1;
    }

    async fetchMember(id) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/" + id,
            method: 'get'
        };
        self.setState({isLoading: true});
        return request(params).then(function (response) {
            self.setState({isLoading: false});
            return response.data;
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });
    }

    async fetchPendingRequest(id) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/change-request/find-by-member/" + id,
            method: 'get'
        };
        self.setState({isLoading: true});
        return request(params).then(function (response) {
            if (response.data !== "") {
                let pendingRequest = response.data;
                let hasPendingRequest = (pendingRequest.processState === "NOT_PROCESSED");
                //      console.log("pendingRequest, hasPendingRequest",pendingRequest, hasPendingRequest);
                self.setState({hasPendingRequest: hasPendingRequest, isLoading: false, pendingRequest: pendingRequest});
                return pendingRequest;
            } else {
                self.setState({isLoading: false});
                return null;
            }
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });
    }

    async fetchChangeRequest(id) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/change-request/" + id,
            method: 'get'
        };
        self.setState({isLoading: true});
        return request(params).then(function (response) {
            if (response.data !== "") {
                let pendingRequest = response.data;
                let hasPendingRequest = (pendingRequest.processState === "NOT_PROCESSED");
                //      console.log("pendingRequest, hasPendingRequest",pendingRequest, hasPendingRequest);
                self.setState({hasPendingRequest: hasPendingRequest, isLoading: false, pendingRequest: pendingRequest});
                return pendingRequest;
            } else {
                self.setState({isLoading: false});
                return null;
            }
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });
    }

    deleteChangeRequest() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/change-request/" + this.state.pendingRequest.id,
            method: 'delete'
        };
        self.setState({isLoading: true});
        request(params).then(() => {
            let changeRequest = self.copyObject(deepCopyObject(self.state.changeRequest), deepCopyObject(self.state.memberInfo));
            delete changeRequest["cityId"];
            delete changeRequest["memberId"];
            delete changeRequest["isActive"];
            delete changeRequest["processState"];
            delete changeRequest["id"];
            delete changeRequest["creationDate"];
            self.setState({changeRequest, hasPendingRequest: false, isLoading: false, pendingRequest: null});
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });
    }

    async listCities() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city/",
            method: "get",
        };
        self.setState({isLoading: true});
        return request(params)
            .then(function (response) {
                self.setState({isLoading: false});
                return response.data;
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });
    }

    async listCitySubdivisions() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city-subdivision",
            method: "get",
        };
        self.setState({isLoading: true});
        return request(params)
            .then(function (response) {
                self.setState({isLoading: false});
                return response.data;
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });
    }

    onChangeAddress(name, value, index, type) {
        let self = this;
        let changeRequest = this.state.changeRequest;
        let addressInfo = changeRequest.addressList;
        if (type === 'string') {
            addressInfo[index][name] = value.toString().toLocaleUpperCase();
        } else {
            if (value === null) {
                addressInfo[index][name] = null;
            } else {
                addressInfo[index][name] = Number(value.value);
            }

            if (name === 'cityId') {
                if (index === 0) {
                    (value !== null) ? this.setState({permanentAdrsCitySubdivisions: getCitySubdivisions_(value.value, this.state.citySubdivisions)}) : this.setState({permanentAdrsCitySubdivisions: null});
                } else if (index === 1) {
                    (value !== null) ? this.setState({workAdrsCitySubdivisions: getCitySubdivisions_(value.value, this.state.citySubdivisions)}) : this.setState({workAdrsCitySubdivisions: null});
                }
                addressInfo[index]['citysubdivisionId'] = null;
            }
        }
        self.setState({changeRequest});
    }

    filterChangedFields(changeRequest, member) {
        let request = {addressList: []};
        //let exclude = ["creationDate", "isActive", "memberId", "processState","cityId" ,"fotoFile"];
        delete changeRequest["cityId"];
        delete changeRequest["memberId"];
        delete changeRequest["isActive"];
        delete changeRequest["processState"];
        delete changeRequest["id"];
        delete changeRequest["creationDate"];
        if (changeRequest !== null) {
            for (const [key, value] of Object.entries(changeRequest)) {
                if (key !== "addressList") {
                    if (!_.isEqual(JSON.stringify(member[key]), JSON.stringify(changeRequest[key]))) {
                        request[key] = deepCopyObject(value);
                        if (key === "fotoThumbFile") {
                            request["fotoFile"] = changeRequest["fotoFile"];
                        }
                    } else {
                        request[key] = null;
                    }
                }
                if (key === "addressList") {
                    for (let i = 0; i < member["addressList"].length; i++) {
                        if (!_.isEqual(JSON.stringify(member["addressList"][i]), JSON.stringify(changeRequest["addressList"][i]))) {
                            request["addressList"].push(deepCopyObject(changeRequest["addressList"][i]));
                        }
                    }
                }
            }
        }

        console.log("returning filtered", request);
        return request;
    }

    addChangedFields(pendingRequest, changeRequest) {
        if (pendingRequest !== null) {
            for (const [key, value] of Object.entries(pendingRequest)) {
                if (pendingRequest[key] !== null && key !== "addressList") {
                    console.log("adding field", key, pendingRequest[key]);
                    changeRequest[key] = deepCopyObject(value);
                }
                if (pendingRequest[key] !== null && key === "addressList") {
                    if (pendingRequest["addressList"].length > 0) {
                        if (pendingRequest["addressList"].filter(item => item.addressType === "PERMANENT").length > 0) {
                            changeRequest["addressList"][0] = pendingRequest["addressList"].filter(item => item.addressType === "PERMANENT")[0];
                        }
                        if (pendingRequest["addressList"].filter(item => item.addressType === "WORK").length > 0) {
                            changeRequest["addressList"][1] = pendingRequest["addressList"].filter(item => item.addressType === "WORK")[0];
                        }
                    }
                }
            }
        }
        return changeRequest;
    }

    isEmtpyRequest(request) {
        let ret = true;
        for (const [key, value] of Object.entries(request)) {
            if (key !== "addressList" && request[key] !== null) {
                console.log("  setting ret to false", key, request[key]);
                ret = false;
                break;
            } else if (key === "addressList" && Array.isArray(request[key]) && request[key].length > 0) {
                console.log(" setting ret to false", key, request[key]);
                ret = false;
                break;
            }
        }
        return ret;
    }

    checkChange(text) {
        let changed = false;
        if (this.state.changeRequest && this.state.memberInfo) {
            let changeRequest = trimObject(deepCopyObject(this.state.changeRequest));
            let memberInfo = deepCopyObject(this.state.memberInfo);
            let item1 = Object.entries(memberInfo).filter(([key, value]) => text === key);
            let item2 = Object.entries(changeRequest).filter(([key, value]) => text === key);
            if (item1 != null && item2 != null) {
                if (!_.isEqual(JSON.stringify(item1), JSON.stringify(item2))) {
                    changed = true;
                }
            }
        }
        return changed ? " fas fa-user-edit" : " ";
    }

    checkChangeAddress(index) {
        let changed = false;
        if (this.state.changeRequest && this.state.memberInfo) {
            let changeRequest = trimObject(deepCopyObject(this.state.changeRequest));
            let memberInfo = deepCopyObject(this.state.memberInfo);
            let changeRequestAddress = changeRequest.addressList;
            let memberInfoAddress = memberInfo.addressList;

            if (changeRequestAddress != null && memberInfoAddress != null) {
                if (!_.isEqual(JSON.stringify(memberInfoAddress[index]), JSON.stringify(changeRequestAddress[index]))) {
                    changed = true;
                }
            }
        }
        return changed ? " fas fa-user-edit" : " ";
    }

    saveChangeRequest() {
        let self = this;
        let params;
        let data;
        let message;
        let validity = this.validateComponent();
        let changeRequest = deepCopyObject(this.state.changeRequest);
        let member = deepCopyObject(this.state.memberInfo);
        let hasPhotoFile = (!(changeRequest.fotoThumbFile === null || changeRequest.fotoThumbFile === ""));

        if (validity.valid && hasPhotoFile) {
            changeRequest = trimObject(changeRequest);
            let finalRequest = this.filterChangedFields(deepCopyObject(changeRequest), deepCopyObject(member));
            console.log("finalRequest", finalRequest)
            if (!this.isEmtpyRequest(finalRequest)) {
                self.setState({isLoading: true});
                finalRequest["id"] = null;
                finalRequest["cityId"] = member.city.id;
                finalRequest["memberId"] = member.id;
                finalRequest["isActive"] = true;
                finalRequest["processState"] = "NOT_PROCESSED";

                data = finalRequest;
                //console.log("data", data);
                message = 'Değişiklik Talebi Başarıyla Kaydedildi.'
                params = {
                    url: API_BASE_URL + "/change-request/create",
                    data: data,
                    method: 'post'
                };

                request(params).then((response) => {
                    Alert.success(
                        message, {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 5000
                        });
                    self.setState({pendingRequest: response.data, hasPendingRequest: true, isLoading: false});
                }).catch(function (error) {
                    self.setState({isLoading: false});
                    showAxiosError(error);
                });
            } else {
                Alert.error(
                    "Hiç Bir Değişiklik Yapmadınız!", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 10000
                    });
            }
        } else {
            let msg = "Hatalı Alanları Düzeltiniz!";
            if (!hasPhotoFile) {
                msg = msg + "</br> Fotoğraf Yükleyiniz!";
            }
            Alert.error(
                msg, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 10000
                });
        }
    }

    approveChangeRequest() {
        let self = this;
        let params;
        let message;

        self.setState({isLoading: true});
        message = 'Üye bilgileri başarıyla güncellendi.'
        params = {
            url: API_BASE_URL + "/change-request/approve/" + self.state.changeRequest.id,
            data: null,
            method: 'post'
        };
        request(params).then(() => {
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            self.setState({isLoading: false});
            this.props.handleSearch();
            this.props.cancelProcess();
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });
    }

    denyChangeRequest() {
        let self = this;
        let params;
        let message;

        self.setState({isLoading: true});
        message = 'Değişikilik Talebi Reddedildi.'
        params = {
            url: API_BASE_URL + "/change-request/deny/" + self.state.changeRequest.id,
            data: null,
            method: 'post'
        };
        request(params).then(() => {
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            self.setState({isLoading: false});
            this.props.handleSearch();
            this.props.cancelProcess();
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });
    }


    onChangeRequest(name, value) {
        let changeRequest = this.state.changeRequest;
        changeRequest[name] = value;
        this.setState({changeRequest});
    }

    onChangeRequestLowerCase(name, value) {
        let changeRequest = this.state.changeRequest;
        changeRequest[name] = value.toString().toLocaleLowerCase();
        this.setState({changeRequest});
    }

    onSelectChange(name, value) {
        let changeRequest = this.state.changeRequest;
        if (value === null) {
            changeRequest[name] = null
        } else {
            changeRequest[name] = value.value;
        }
        this.setState({changeRequest});
    }

    onChangeDateString(name, value) {
        if (value === "") {
            value = null;
        }
        if (value !== null) {
            let splitted = value.split(".");
            value = splitted[2] + "-" + splitted[1] + "-" + splitted[0];
        }
        let changeRequest = this.state.changeRequest;
        changeRequest[name] = value;
        this.setState({changeRequest});
    }

    render() {
        const medeniHalOptions = [
            {label: 'BEKAR', value: 'BEKAR'},
            {label: 'EVLI', value: 'EVLI'},
            {label: 'DUL', value: 'DUL'}
        ];

        let tDogumTarihi = this.state.changeRequest.dogumTarihi ? {value: moment.utc(this.state.changeRequest.dogumTarihi, "YYYY-MM-DD")} : {};
        let tMezuniyetTarihi = this.state.changeRequest.mezuniyetTarihi ? {value: moment.utc(this.state.changeRequest.mezuniyetTarihi, "YYYY-MM-DD")} : {};
        let tRuhsatTarihi = this.state.changeRequest.ruhsatTarihi ? {value: moment.utc(this.state.changeRequest.ruhsatTarihi, "YYYY-MM-DD")} : {};

        return (
            <div>
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="memberForm-container">
                    {this.state.mode && this.state.mode === 'edit' &&
                    <div className="page-title">
                        <br/>BİRLİK KAYIT / İLETİŞİM BİLGİLERİNİZ<br/>
                    </div>
                    }
                    <Form>

                        {/* <div className="row col-sm-12">
                            <Label className="col-sm-3">İl:</Label>
                            <div className={"col-sm-9 form-group" + this.validateClass('tCity')}>
                                <Input className="form-control"
                                       disabled={this.state.isLoading}
                                       type="text"
                                       name="city"
                                       id="tCity"
                                       maxLength="50"
                                       data-vlength="1,50"
                                       inputProps={{'vdata': "required", 'vlength': "1,50"}}
                                       onBlur={this.validateField}
                                       ref="tCity"
                                       value={this.state.changeRequest.city.ad}
                                       onChange={(e)=>this.onChangeRequest("city",e.target.value)} />
                                {this.validateMessage('tCity') !== "" &&
                                <UncontrolledTooltip placement="right" target="tCity" delay={0}>
                                    {this.validateMessage("tCity")}
                                </UncontrolledTooltip>}

                            </div>
                        </div>*/}
                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Ad:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tAd')}>
                                <Input className="form-control"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       type="text"
                                       name="ad"
                                       id="ad"
                                       maxLength="50"
                                       data-vlength="1,50"
                                       inputProps={{'vdata': "required", 'vlength': "1,50"}}
                                       onBlur={this.validateField}
                                       ref="tAd"
                                       value={this.state.changeRequest.ad}
                                       onChange={(e) => this.onChangeRequest("ad", e.target.value)}/>
                                {this.validateMessage('tAd') !== "" &&
                                <UncontrolledTooltip placement="right" target="tAd" delay={0}>
                                    {this.validateMessage("tAd")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("ad")}/>
                        </div>
                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Soyad:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tSoyad')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="soyad"
                                       id="soyad"
                                       maxLength="50"
                                       data-vlength="1,50"
                                       inputProps={{'vdata': "required", 'vlength': "1,50"}}
                                       onBlur={this.validateField}
                                       ref="tSoyad"
                                       value={this.state.changeRequest.soyad}
                                       onChange={(e) => this.onChangeRequest("soyad", e.target.value)}/>
                                {this.validateMessage('tSoyad') !== "" &&
                                <UncontrolledTooltip placement="right" target="tSoyad" delay={0}>
                                    {this.validateMessage("tSoyad")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("soyad")}/>
                        </div>
                        <div className="row col-sm-12">
                            <Label className="col-sm-3">TC Kimlik No:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tTckNo')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="tckNo"
                                       id="tTckNo"
                                       maxLength="11"
                                       data-vlength="11"
                                       onBlur={this.validateField}
                                       inputProps={{'vdata': "required", 'vlength': "11"}}
                                       ref="tTckNo"
                                       value={this.state.changeRequest.tcKimlikNo}
                                       onChange={(e) => this.onChangeRequest("tcKimlikNo", e.target.value)}/>
                                {this.validateMessage('tTckNo') !== "" &&
                                <UncontrolledTooltip placement="right" target="tTckNo" delay={0}>
                                    {this.validateMessage("tTckNo")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("tcKimlikNo")}/>
                        </div>


                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Doğum Tarihi:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tDogumTarihi')}>
                                <DatePicker {...tDogumTarihi}
                                            className="basic-single"
                                            placeholder="Tarih seçiniz."
                                            disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                            classNamePrefix="select"
                                            format="DD.MM.YYYY"
                                            isClearable={true}
                                            isSearchable={true}
                                            onBlur={this.validateField}
                                            name="dogumTarihi"
                                            id="tDogumTarihi"
                                            ref="tDogumTarihi"
                                            style={{width: 120}}
                                            inputProps={{'vdata': "required"}}
                                            onChange={(date, dateString) => this.onChangeDateString("dogumTarihi", dateString)}/>
                                {this.validateMessage('tDogumTarihi') !== "" &&
                                <UncontrolledTooltip placement="right" target="tDogumTarihi" delay={0}>
                                    {this.validateMessage("tDogumTarihi")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("dogumTarihi")}/>

                        </div>

                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Baba Adı:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tBabaAdi')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="babaAdi"
                                       id="tBabaAdi"
                                       maxLength="50"
                                       data-vlength="1,50"
                                       inputProps={{'vdata': "required", 'vlength': "1,50"}}
                                       onBlur={this.validateField}
                                       ref="tBabaAdi"
                                       value={this.state.changeRequest.babaAdi}
                                       onChange={(e) => this.onChangeRequest("babaAdi", e.target.value)}/>
                                {this.validateMessage('tBabaAdi') !== "" &&
                                <UncontrolledTooltip placement="right" target="tBabaAdi" delay={0}>
                                    {this.validateMessage("tBabaAdi")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("babaAdi")}/>

                        </div>

                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Ana Adı:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tAnaAdi')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="anaAdi"
                                       id="tAnaAdi"
                                       maxLength="50"
                                       data-vlength="1,50"
                                       inputProps={{'vdata': "required", 'vlength': "1,50"}}
                                       onBlur={this.validateField}
                                       ref="tAnaAdi"
                                       value={this.state.changeRequest.anaAdi}
                                       onChange={(e) => this.onChangeRequest("anaAdi", e.target.value)}/>
                                {this.validateMessage('tAnaAdi') !== "" &&
                                <UncontrolledTooltip placement="right" target="tAnaAdi" delay={0}>
                                    {this.validateMessage("tAnaAdi")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("anaAdi")}/>

                        </div>

                        {/* <div className="row col-sm-12">
                            <Label className="col-sm-3">Kimlik Tipi:</Label>
                            <div className={"col-sm-9 form-group" + this.validateClass('tKimlikTipi')}>
                                <Select
                                    className="basic-single"
                                    disabled={this.state.isLoading || this.state.hasPendingRequest}
                                    classNamePrefix="select"
                                    placeholder="Seçiniz"
                                    isClearable={false}
                                    isSearchable={false}
                                    name="kimlikTipi"
                                    id="tKimlikTipi"
                                    ref="tKimlikTipi"
                                    style={{ width: 120 }}
                                    inputProps={{'vdata': "required"}}
                                    options={KimlikTipiOptions}
                                    onChange={(value)=>this.onMedeniHalChange("kimlikTipi",value)}

                                    value={this.state.changeRequest.kimlikTipi} />
                                {this.validateMessage('tKimlikTipi') !== "" &&
                                <UncontrolledTooltip placement="right" target="tKimlikTipi" delay={0}>
                                    {this.validateMessage("tKimlikTipi")}
                                </UncontrolledTooltip>}

                            </div>
                        </div>


                        <div className="row col-sm-12">
                            <Label className="col-sm-3">N.Cüzdanı/TC Kimlik Seri No:</Label>
                            <div className={"col-sm-9 form-group" + this.validateClass('tCuzdanKimlikSeriNo')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest}
                                       name="cuzdanKimlikSeriNo"
                                       id="tCuzdanKimlikSeriNo"
                                       maxLength="50"
                                       data-vlength="50"
                                       inputProps={{'vdata': "required", 'vlength': "50"}}
                                       ref="tCuzdanKimlikSeriNo"
                                       value={this.state.changeRequest.cuzdanKimlikSeriNo}
                                       onChange={(e)=>this.onChangeRequest("cuzdanKimlikSeriNo",e.target.value)} />
                                {this.validateMessage('tCuzdanKimlikSeriNo') !== "" &&
                                <UncontrolledTooltip placement="right" target="tCuzdanKimlikSeriNo" delay={0}>
                                    {this.validateMessage("tCuzdanKimlikSeriNo")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>

                        {
                            (this.state.changeRequest.kimlikTipi === "NufusCuzdani")
                                ?
                                <div className="row col-sm-12">
                                    <Label className="col-sm-3">Kimlik Kayıt No:</Label>
                                    <div className={"col-sm-9 form-group" + this.validateClass('tKayitNo')}>
                                        <Input className="form-control"
                                               type="text"
                                               disabled={this.state.isLoading || this.state.hasPendingRequest}
                                               name="KayitNo"
                                               id="tKayitNo"
                                               maxLength="50"
                                               data-vlength="50"
                                               inputProps={{'vdata': "required", 'vlength': "50"}}
                                               ref="tKayitNo"
                                               value={this.state.changeRequest.kayitNo}
                                               onChange={(e) => this.onChangeRequest("kayitNo", e.target.value)}/>
                                        {this.validateMessage('tKayitNo') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tKayitNo" delay={0}>
                                            {this.validateMessage("tKayitNo")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                                :
                                ""
                        }

                        {
                            (this.state.changeRequest.kimlikTipi === "TCKimlikKarti")
                                ?
                                <div className="row col-sm-12">
                                    <Label className="col-sm-3">Kimlik Son Geçerlilik Tarihi:</Label>
                                    <div
                                        className={"col-sm-9 form-group" + this.validateClass('tKimlikSonGecerlilikTarihi')}>
                                        <DatePicker {...tKimlikSonGecerlilikTarihi}
                                                    className="basic-single"
                                                    placeholder="Tarih seçiniz."
                                                    disabled={this.state.isLoading || this.state.hasPendingRequest}
                                                    classNamePrefix="select"
                                                    format="DD.MM.YYYY"
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    name="kimlikSonGecerlilikTarihi"
                                                    id="tKimlikSonGecerlilikTarihi"
                                                    ref="tKimlikSonGecerlilikTarihi"
                                                    style={{width: 120}}
                                                    inputProps={{'vdata': "required"}}
                                                    onChange={(date,dateString)=>this.onChangeDateString("kimlikSonGecerlilikTarihi",dateString)}/>

                                        {this.validateMessage('tKimlikSonGecerlilikTarihi') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tKimlikSonGecerlilikTarihi"
                                                             delay={0}>
                                            {this.validateMessage("tKimlikSonGecerlilikTarihi")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                                :
                                ""
                        }
                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Doğum Yeri:</Label>
                            <div className={"col-sm-9 form-group" + this.validateClass('tDogumYeri')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest}
                                       name="dogumYeri"
                                       id="tDogumYeri"
                                       maxLength="50"
                                       data-vlength="50"
                                       inputProps={{'vdata': "required", 'vlength': "50"}}
                                       ref="tDogumYeri"
                                       value={this.state.changeRequest.dogumYeri}
                                       onChange={(e)=>this.onChangeRequest("dogumYeri",e.target.value)} />
                                {this.validateMessage('tDogumYeri') !== "" &&
                                <UncontrolledTooltip placement="right" target="tDogumYeri" delay={0}>
                                    {this.validateMessage("tDogumYeri")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>
*/}

                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Üniversite:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tUniversite')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="universite"
                                       id="tUniversite"
                                       maxLength="50"
                                    // data-vlength="5,50"
                                    // inputProps={{'vdata': "required", 'vlength': "5,50"}}
                                    // ref="tUniversite"
                                    //onBlur={this.validateField}
                                       value={this.state.changeRequest.universite}
                                       onChange={(e) => this.onChangeRequest("universite", e.target.value)}/>
                                {this.validateMessage('tUniversite') !== "" &&
                                <UncontrolledTooltip placement="right" target="tUniversite" delay={0}>
                                    {this.validateMessage("tUniversite")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("universite")}/>
                        </div>


                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Mezuniyet Tarihi:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tMezuniyetTarihi')}>
                                <DatePicker {...tMezuniyetTarihi}
                                            className="basic-single"
                                            placeholder="Tarih seçiniz."
                                            disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                            classNamePrefix="select"
                                            format="DD.MM.YYYY"
                                            isClearable={true}
                                            isSearchable={true}
                                            name="mezuniyetTarihi"
                                            id="tMezuniyetTarihi"
                                    // ref="tMezuniyetTarihi"
                                            style={{width: 120}}
                                    // inputProps={{'vdata': "required"}}
                                            onChange={(date, dateString) => this.onChangeDateString("mezuniyetTarihi", dateString)}/>
                                {this.validateMessage('tMezuniyetTarihi') !== "" &&
                                <UncontrolledTooltip placement="right" target="tMezuniyetTarihi" delay={0}>
                                    {this.validateMessage("tMezuniyetTarihi")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("mezuniyetTarihi")}/>
                        </div>


                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Diploma No:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tDiplomaNo')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="diplomaNo"
                                       id="tDiplomaNo"
                                       maxLength="50"
                                    // data-vlength="5,50"
                                    // inputProps={{'vdata': "required", 'vlength': "5,50"}}
                                    // ref="tDiplomaNo"
                                    //onBlur={this.validateField}
                                       value={this.state.changeRequest.diplomaNo}
                                       onChange={(e) => this.onChangeRequest("diplomaNo", e.target.value)}/>
                                {this.validateMessage('tDiplomaNo') !== "" &&
                                <UncontrolledTooltip placement="right" target="tDiplomaNo" delay={0}>
                                    {this.validateMessage("tDiplomaNo")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("diplomaNo")}/>
                        </div>

                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Ruhsat No:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tRuhsatNo')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="ruhsatNo"
                                       id="tRuhsatNo"
                                       maxLength="50"
                                       data-vlength="2,50"
                                       inputProps={{'vdata': "required", 'vlength': "2,50"}}
                                       ref="tRuhsatNo"
                                       onBlur={this.validateField}
                                       value={this.state.changeRequest.ruhsatNo}
                                       onChange={(e) => this.onChangeRequest("ruhsatNo", e.target.value)}/>
                                {this.validateMessage('tRuhsatNo') !== "" &&
                                <UncontrolledTooltip placement="right" target="tRuhsatNo" delay={0}>
                                    {this.validateMessage("tRuhsatNo")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("ruhsatNo")}/>
                        </div>

                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Ruhsat Tarihi:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tRuhsatTarihi')}>
                                <DatePicker {...tRuhsatTarihi}
                                            className="basic-single"
                                            placeholder="Tarih seçiniz."
                                            disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                            classNamePrefix="select"
                                            format="DD.MM.YYYY"
                                            isClearable={true}
                                            isSearchable={true}
                                            name="ruhsatTarihi"
                                            id="tRuhsatTarihi"
                                            ref="tRuhsatTarihi"
                                            style={{width: 120}}
                                            inputProps={{'vdata': "required"}}
                                            onChange={(date, dateString) => this.onChangeDateString("ruhsatTarihi", dateString)}/>
                                {this.validateMessage('tRuhsatTarihi') !== "" &&
                                <UncontrolledTooltip placement="right" target="tRuhsatTarihi" delay={0}>
                                    {this.validateMessage("tRuhsatTarihi")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("ruhsatTarihi")}/>
                        </div>

                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Vergi Dairesi:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tVergiDairesiAd')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="vergiDairesiAd"
                                       id="tVergiDairesiAd"
                                       maxLength="50"
                                       data-vlength="50"
                                       inputProps={{'vdata': "required", 'vlength': "50"}}
                                    //ref="tVergiDairesiAd"
                                       value={this.state.changeRequest.vergiDairesiAd}
                                       onChange={(e) => this.onChangeRequest("vergiDairesiAd", e.target.value)}/>
                                {this.validateMessage('tVergiDairesiAd') !== "" &&
                                <UncontrolledTooltip placement="right" target="tVergiDairesiAd" delay={0}>
                                    {this.validateMessage("tVergiDairesiAd")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("vergiDairesiAd")}/>
                        </div>

                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Vergi No:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tVergiNo')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="tVergiNo"
                                       id="tVergiNo"
                                       maxLength="50"
                                       data-vlength="50"
                                       inputProps={{'vdata': "required", 'vlength': "50"}}
                                    // ref="tVergiNo"
                                       value={this.state.changeRequest.vergiNo}
                                       onChange={(e) => this.onChangeRequest("vergiNo", e.target.value)}/>
                                {this.validateMessage('tVergiNo') !== "" &&
                                <UncontrolledTooltip placement="right" target="tVergiNo" delay={0}>
                                    {this.validateMessage("tVergiNo")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("vergiNo")}/>
                        </div>
                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Medeni Hali:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tMedeniHali')}>
                                <Select
                                    className="basic-single"
                                    disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                    classNamePrefix="select"
                                    placeholder="Seçiniz"
                                    isClearable={false}
                                    isSearchable={false}
                                    name="medeniHal"
                                    id="tMedeniHali"
                                    ref="tMedeniHali"
                                    style={{width: 120}}
                                    inputProps={{'vdata': "required"}}
                                    options={medeniHalOptions}
                                    onChange={(value) => this.onSelectChange("medeniHali", value)}
                                    value={this.state.changeRequest.medeniHali}/>
                                {this.validateMessage('tMedeniHali') !== "" &&
                                <UncontrolledTooltip placement="right" target="tMedeniHali" delay={0}>
                                    {this.validateMessage("tMedeniHali")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("medeniHali")}/>
                        </div>


                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Kan Grubu:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tKanGrubu')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="kanGrubu"
                                       id="tKanGrubu"
                                       maxLength="7"
                                       data-vlength="2,7"
                                       inputProps={{'vdata': "required", 'vlength': "2,7"}}
                                       ref="tKanGrubu"
                                       onBlur={this.validateField}
                                       value={this.state.changeRequest.kanGrubu}
                                       onChange={(e) => this.onChangeRequest("kanGrubu", e.target.value)}/>
                                {this.validateMessage('tKanGrubu') !== "" &&
                                <UncontrolledTooltip placement="right" target="tKanGrubu" delay={0}>
                                    {this.validateMessage("tKanGrubu")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("kanGrubu")}/>
                        </div>
                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Fotoğraf:</Label>
                            <div className="col-sm-8 form-group">
                                <Uploader2 onInfoChange={this.onChangeRequest}
                                           fileName="fotoFile"
                                           thumbFileName="fotoThumbFile"
                                           filePathName="fotoPath"
                                           pathPrefix="foto"
                                           memberTCKN={this.state.changeRequest.tcKimlikNo}
                                           filePath={this.state.changeRequest.fotoPath}
                                           file={this.state.changeRequest.fotoFile}
                                           thumb={this.state.changeRequest.fotoThumbFile}
                                           isDisabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}/>
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("fotoThumbFile")}/>
                        </div>

                        <div className='row col-sm-12'>
                            <label className="col-sm-3">E-posta:</label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tEmail')}>
                                <Maskedinput className="form-control"
                                             disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                             type="text"
                                             mask={emailMask}
                                             name="email"
                                             inputProps={{vdata: "email", vlength: '1,255'}}
                                             id="tEmail"
                                             onBlur={() => this.validateField({
                                                 target: {
                                                     id: "tEmail",
                                                     dataset: {vdata: "email", vlength: '1,255'},
                                                     value: this.state.changeRequest.email
                                                 }
                                             })}
                                             placeholder="_________@______.___"
                                             ref="tEmail"
                                             value={this.state.changeRequest.email}
                                             onChange={(e) => this.onChangeRequestLowerCase("email", e.target.value)}
                                />
                                {this.validateMessage('tEmail') !== "" &&
                                <UncontrolledTooltip placement="right" target="tEmail" delay={0}>
                                    {this.validateMessage("tEmail")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("email")}/>
                        </div>

                        <div className="row  col-sm-12">
                            <Label className="col-sm-3">GSM Telefonu:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tGsmTel')}>
                                <input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="gsmTel"
                                       id="tGsmTel"
                                       maxLength="10"
                                       data-vlength="10"
                                       inputProps={{'vdata': "required", 'vlength': "10"}}
                                       onBlur={this.validateField}
                                       ref="tGsmTel"
                                       value={this.state.changeRequest.gsmTel}
                                       onChange={(e) => this.onChangeRequest("gsmTel", e.target.value)}/>
                                {this.validateMessage('tGsmTel') !== "" &&
                                <UncontrolledTooltip placement="right" target="tGsmTel" delay={0}>
                                    {this.validateMessage("tGsmTel")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("gsmTel")}/>
                        </div>

                        <div className="row col-sm-12">
                            <Label className="col-sm-3">İş Yeri Telefonu:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tIsTel')}>
                                <input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || !this.state.changeRequest.uyeCalisiyor || (this.props.mode !== "edit")}
                                       name="isTel"
                                       id="tIsTel"
                                       maxLength="10"
                                       value={this.state.changeRequest.isTel}
                                       onChange={(e) => this.onChangeRequest("isTel", e.target.value)}/>
                                {this.validateMessage('tIsTel') !== "" &&
                                <UncontrolledTooltip placement="right" target="tIsTel" delay={0}>
                                    {this.validateMessage("tIsTel")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("isTel")}/>
                        </div>

                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Ev Telefonu:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tEvTel')}>
                                <input className="form-control"
                                       type="text"
                                       disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                       name="evTel"
                                       id="tEvTel"
                                       maxLength="10"
                                       value={this.state.changeRequest.evTel}
                                       onChange={(e) => this.onChangeRequest("evTel", e.target.value)}/>
                                {this.validateMessage('tEvTel') !== "" &&
                                <UncontrolledTooltip placement="right" target="tEvTel" delay={0}>
                                    {this.validateMessage("tEvTel")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChange("evTel")}/>
                        </div>

                        <div className="row col-sm-12">
                            <Label className="col-sm-3">İkamet Adresi:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tPermAdres')}>
                                <TextArea className="form-control"
                                          type="text"
                                          disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                          name="permAdres"
                                          id="tPermAdres"
                                          maxLength="255"
                                          ref="tPermAdres"
                                          onBlur={this.validateField}
                                          data-vlength="10,250"
                                          inputProps={{'vdata': "required", 'vlength': "10,250"}}
                                          style={{height: 60, minHeight: 60}}
                                          value={this.state.changeRequest.addressList[0] && this.state.changeRequest.addressList[0].addressString}
                                          onChange={(e) => this.onChangeAddress("addressString", e.target.value, 0, 'string')}/>
                                {this.validateMessage('tPermAdres') !== "" &&
                                <UncontrolledTooltip placement="right" target="tPermAdres" delay={0}>
                                    {this.validateMessage("tPermAdres")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChangeAddress(0)}/>
                        </div>
                        <div className="row col-sm-12">
                            <Label className="col-sm-3">İkamet İl/İlçe: </Label>
                            <div className={"col-sm-4 form-group" + this.validateClass('tPermAdrsCity')}>
                                <Select
                                    className="basic-single"
                                    disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                    classNamePrefix="select"
                                    placeholder="İl seçiniz."
                                    isClearable={false}
                                    isSearchable={true}
                                    name="permAdrsCity"
                                    id="tPermAdrsCity"
                                    ref="tPermAdrsCity"
                                    inputProps={{'vdata': "required"}}
                                    style={{flex: 0.9}}
                                    options={this.state.permanentAdrsCities}
                                    onChange={(value) => this.onChangeAddress("cityId", value, 0, 'select')}
                                    value={this.state.changeRequest.addressList[0] && this.state.changeRequest.addressList[0].cityId}/>
                                {this.validateMessage('tPermAdrsCity') !== "" &&
                                <UncontrolledTooltip placement="right" target="tPermAdrsCity" delay={0}>
                                    {this.validateMessage("tPermAdrsCity")}
                                </UncontrolledTooltip>}
                            </div>
                            <div className={"col-sm-4 form-group" + this.validateClass('tPermAdrsCitySub')}>
                                <Select
                                    className="basic-single"
                                    disabled={this.state.isLoading || this.state.hasPendingRequest || (this.props.mode !== "edit")}
                                    classNamePrefix="select"
                                    placeholder="İlçe seçiniz."
                                    isClearable={false}
                                    isSearchable={true}
                                    name="permAdrsCitySub"
                                    id="tPermAdrsCitySub"
                                    ref="tPermAdrsCitySub"
                                    inputProps={{'vdata': "required"}}
                                    style={{flex: 0.9}}
                                    options={this.state.permanentAdrsCitySubdivisions}
                                    onChange={(value) => this.onChangeAddress("citysubdivisionId", value, 0, 'select')}
                                    value={this.state.changeRequest.addressList[0] && this.state.changeRequest.addressList[0].citysubdivisionId}/>
                                {this.validateMessage('tPermAdrsCitySub') !== "" &&
                                <UncontrolledTooltip placement="right" target="tPermAdrsCitySub" delay={0}>
                                    {this.validateMessage("tPermAdrsCitySub")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>
                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Semt: </Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tPermSemt')}>
                                <input className="form-control"
                                       type="text"
                                       disabled={this.state.fieldsDisabled}
                                       name="permSemt"
                                       id="tPermSemt"
                                       maxLength="10"
                                       value={this.state.memberInfo.addressList[0] && this.state.memberInfo.addressList[0].permSemt}
                                       onChange={(e) => this.onChangeAddress("permSemt", e.target.value, 0, 'string')}/>
                                {this.validateMessage('tPermSemt') !== "" &&
                                <UncontrolledTooltip placement="right" target="tPermSemt" delay={0}>
                                    {this.validateMessage("tPermSemt")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>

                        <div className="row col-sm-12">
                            <Label className="col-sm-3">İş Yeri Adresi:</Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tWorkAdres')}>
                                <TextArea className="form-control"
                                          type="text"
                                          disabled={this.state.isLoading || this.state.hasPendingRequest || !this.state.changeRequest.uyeCalisiyor || (this.props.mode !== "edit")}
                                          name="workAdres"
                                          id="tWorkAdres"
                                          maxLength="255"
                                          data-vlength="10,250"
                                          onBlur={this.validateField}
                                          ref="tWorkAdres"
                                          inputProps={{'vdata': "required", 'vlength': "10,250"}}
                                          style={{height: 60, minHeight: 60}}
                                          value={this.state.changeRequest.addressList[1] && this.state.changeRequest.addressList[1].addressString}
                                          onChange={(e) => this.onChangeAddress("addressString", e.target.value, 1, 'string')}/>
                                {this.validateMessage('tWorkAdres') !== "" &&
                                <UncontrolledTooltip placement="right" target="tWorkAdres" delay={0}>
                                    {this.validateMessage("tWorkAdres")}
                                </UncontrolledTooltip>}
                            </div>
                            <i style={{color: "rgb(205,20,18)", marginBottom: "5px", marginLeft: "-5px"}}
                               className={"col-sm-1 " + this.checkChangeAddress(1)}/>
                        </div>
                        <div className="row col-sm-12">
                            <Label className="col-sm-3">İş Yeri İl/İlçe: </Label>
                            <div className={"col-sm-4 form-group" + this.validateClass('tWorkAdresCity')}>
                                <Select
                                    className="basic-single"
                                    disabled={this.state.isLoading || this.state.hasPendingRequest || !this.state.changeRequest.uyeCalisiyor || (this.props.mode !== "edit")}
                                    classNamePrefix="select"
                                    placeholder="İl seçiniz."
                                    isClearable={false}
                                    isSearchable={true}
                                    name="workAdresCity"
                                    id="tWorkAdresCity"
                                    ref="tWorkAdresCity"
                                    inputProps={{'vdata': "required"}}
                                    style={{flex: 0.9}}
                                    options={this.state.workAdrsCities}
                                    onChange={(value) => this.onChangeAddress("cityId", value, 1, 'select')}
                                    value={this.state.changeRequest.addressList[1] && this.state.changeRequest.addressList[1].cityId}/>
                                {this.validateMessage('tWorkAdresCity') !== "" &&
                                <UncontrolledTooltip placement="right" target="tWorkAdresCity" delay={0}>
                                    {this.validateMessage("tWorkAdresCity")}
                                </UncontrolledTooltip>}
                            </div>
                            <div className={"col-sm-4 form-group" + this.validateClass('tWorkAdresCitySub')}>
                                <Select
                                    className="basic-single"
                                    disabled={this.state.isLoading || this.state.hasPendingRequest || !this.state.changeRequest.uyeCalisiyor || (this.props.mode !== "edit")}
                                    classNamePrefix="select"
                                    placeholder="İlçe seçiniz."
                                    isClearable={false}
                                    isSearchable={true}
                                    name="workAdresCitySub"
                                    id="tWorkAdresCitySub"
                                    ref="tWorkAdresCitySub"
                                    inputProps={{'vdata': "required"}}
                                    style={{flex: 0.9}}
                                    options={this.state.workAdrsCitySubdivisions}
                                    onChange={(value) => this.onChangeAddress("citysubdivisionId", value, 1, 'select')}
                                    value={this.state.changeRequest.addressList[1] && this.state.changeRequest.addressList[1].citysubdivisionId}/>
                                {this.validateMessage('tWorkAdresCitySub') !== "" &&
                                <UncontrolledTooltip placement="right" target="tWorkAdresCitySub" delay={0}>
                                    {this.validateMessage("tWorkAdresCitySub")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>
                        <div className="row col-sm-12">
                            <Label className="col-sm-3">Semt: </Label>
                            <div className={"col-sm-8 form-group" + this.validateClass('tWorkSemt')}>
                                <input className="form-control"
                                       type="text"
                                       disabled={this.state.fieldsDisabled}
                                       name="workSemt"
                                       id="tWorkSemt"
                                       maxLength="10"
                                       value={this.state.memberInfo.addressList[1] && this.state.memberInfo.addressList[1].workSemt}
                                       onChange={(e) => this.onChangeAddress("workSemt", e.target.value, 0, 'string')}/>
                                {this.validateMessage('tWorkSemt') !== "" &&
                                <UncontrolledTooltip placement="right" target="tWorkSemt" delay={0}>
                                    {this.validateMessage("tWorkSemt")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>
                        {(this.state.mode === 'edit') && (!this.state.hasPendingRequest) &&
                        <div className="save-button-container col-sm-12 row">
                            <br/>
                            <Label className="col-sm-10" style={{
                                color: "green",
                                fontWeight: "bold"
                            }}>
                                {this.state.mode === 'edit' && this.state.pendingRequest && this.state.pendingRequest.creationDate &&
                                moment(this.state.pendingRequest.creationDate).format("DD.MM.YYYY HH:MM") +
                                " tarihli son bilgi değişikliği talebiniz"}
                                {(this.state.mode === 'edit') && this.state.pendingRequest ? (this.state.pendingRequest.processState === "APPROVED") ? " onaylanmıştır." : " reddedilmiştir." : ""
                                }
                            </Label>
                            <button onClick={() => {
                                this.saveChangeRequest()
                            }}
                                    className="member-save-button"
                                    disabled={this.state.isLoading}
                            >DEĞİŞİKLİKLERİ KAYDET
                            </button>
                        </div>
                        }

                        {(this.state.mode === 'edit') && this.state.hasPendingRequest &&
                        <div className="save-button-container col-sm-12 row">
                            <br/>
                            <Label className="col-sm-10" style={{
                                color: "red",
                                fontWeight: "bold"
                            }}>{this.state.pendingRequest && this.state.pendingRequest.creationDate &&
                            moment(this.state.pendingRequest.creationDate).format("DD.MM.YYYY HH:MM") +
                            " tarihli bilgi değişikliği talebiniz sistemde onay beklemektedir. İsterseniz bu talebinizi silebilirsiniz."}
                            </Label>
                            <button onClick={() => {
                                this.deleteChangeRequest()
                            }}
                                    className="member-delete-button"
                                    disabled={this.state.isLoading}>BEKLEYEN DEĞİŞİKLİK TALEBİNİ SİL
                            </button>
                        </div>
                        }

                        {(this.state.mode === 'review') &&
                        <div style={{margin: "auto"}} className="save-button-container col-sm-10 row">
                            <div className="save-button-container col-sm-6">
                                <button onClick={() => {
                                    this.denyChangeRequest()
                                }}
                                        className="change-deny-button"
                                        disabled={this.state.isLoading}
                                > REDDET
                                </button>
                            </div>
                            <div className="save-button-container col-sm-6">
                                <button onClick={() => {
                                    this.approveChangeRequest()
                                }}
                                        className="change-save-button"
                                        disabled={this.state.isLoading}
                                > ONAYLA
                                </button>
                            </div>
                        </div>
                        }
                    </Form>
                </div>
            </div>
        )
    }
}

export default MemberGeneralInfo;



// WEBPACK FOOTER //
// ./src/page/memberList/MemberGeneralInfo.js